import { Flex, Text } from "@chakra-ui/react";
import { useCallback } from "react";
import { AiOutlineCloudUpload } from "react-icons/ai";
import { MdOutlineSave } from "react-icons/md";
import { FormattedMessage, useIntl } from "react-intl";

import { RanaModal, RightArrowIcon } from "@nens/ranalib";

import { getId, useEditPublication, usePublicationStore } from "../../../_internal";
import { SaveChangesButton } from "../../action-bar/components/save-changes-button";
export const UnsavedChangesModal = ({
  onClose,
  proceed,
}: {
  onClose: () => void;
  proceed: () => void;
}) => {
  const intl = useIntl();
  const publicationId = usePublicationStore(getId);
  const publishVersion = usePublicationStore((store) => store.publishVersion);
  const { mutate: editPublication } = useEditPublication();

  const doPublish = useCallback(
    (version: number) => {
      // First update publication through the API
      editPublication(
        {
          publicationId,
          publicationUpdate: {
            publishedVersion: version,
          },
        },
        {
          onSuccess: () => {
            // Then set in Zustand and proceed to share modal
            publishVersion(version);
            proceed();
          },
        }
      );
    },
    [editPublication, proceed, publicationId, publishVersion]
  );
  return (
    <RanaModal
      topBar={
        <FormattedMessage id="header.unsaved_changes" defaultMessage="You have unsaved changes" />
      }
      onClose={onClose}
      buttons={[
        <SaveChangesButton
          key="save-changes-button"
          buttonText={intl.formatMessage({
            id: "common.save_to_draft",
            defaultMessage: "Save to draft",
          })}
          canSaveChanges
          onSuccess={onClose}
          variant="tertiary"
        />,
        {
          children: (
            <FormattedMessage
              id="common.create_without_saving"
              defaultMessage="Share without saving"
            />
          ),
          leftIcon: <RightArrowIcon />,
          variant: "primary",
          onClick: proceed,
        },

        <SaveChangesButton
          key="save-changes-and-publish-button"
          buttonText={intl.formatMessage({
            id: "common.save_and_publish_then_share",
            defaultMessage: "Save and publish then share",
          })}
          canSaveChanges
          onSuccess={doPublish}
          leftIcon={
            <Flex gap={1} alignItems="center">
              <MdOutlineSave />
              +
              <AiOutlineCloudUpload />
            </Flex>
          }
        />,
      ]}
      isOpen
    >
      <Text>
        <FormattedMessage
          id="header.you_changed_a_default_value"
          defaultMessage="You have made changes to a default value of this publication (likely the visibility of a layer)."
        />
      </Text>
      <Text>
        <FormattedMessage
          id="header.choose_one_of_the_options_below"
          defaultMessage="Choose one of the options below."
        />
      </Text>
    </RanaModal>
  );
};
